(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/item.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/item.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const InputNumber = svs.components.input_number.InputNumber;
const Icon = svs.ui.ReactIcon;
const IconButton = svs.ui.ReactIconButton;
const Image = svs.content.image_v2.Image;
const _svs$tickets_giftshop = svs.tickets_giftshop.constants.cart,
  SET = _svs$tickets_giftshop.SET,
  APPEND = _svs$tickets_giftshop.APPEND;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.gift.giftform.cart.actions,
  removeProductGroupAction = _svs$tickets_giftshop2.removeProductGroupAction,
  setProductAction = _svs$tickets_giftshop2.setProductAction,
  setRenderAnimationCompleteAction = _svs$tickets_giftshop2.setRenderAnimationCompleteAction;
const animations = svs.tickets_giftshop.gift.giftform.cart.animations;
const Item = _ref => {
  let lastUpdatedFromType = _ref.lastUpdatedFromType,
    isAnimatingOnRender = _ref.isAnimatingOnRender,
    onRenderAnimationComplete = _ref.onRenderAnimationComplete,
    amount = _ref.amount,
    onProductGroupRemove = _ref.onProductGroupRemove,
    onProductAmountChange = _ref.onProductAmountChange,
    product = _ref.product;
  const _ref2 = product || {},
    productVariation = _ref2.productVariation,
    productId = _ref2.productId,
    productImage = _ref2.productImage,
    productName = _ref2.productName,
    productPrice = _ref2.productPrice,
    type = _ref2.type,
    skinId = _ref2.skinId;
  const cartItem = React.useRef(null);
  const cartItemImage = React.useRef(null);
  const _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isFirstRender = _React$useState2[0],
    setIsFirstRender = _React$useState2[1];
  const handleProductRemoveClick = e => {
    e && e.preventDefault();
    if (cartItem.current) {
      const animateRemove = animations.removeListItem(cartItem.current);
      animateRemove.eventCallback('onComplete', () => {
        onProductGroupRemove && onProductGroupRemove(productId, productVariation, type, skinId);
      });
      animateRemove.play();
    } else {
      onProductGroupRemove && onProductGroupRemove(productId, productVariation, type, skinId);
    }
  };
  React.useEffect(() => {
    if (!isFirstRender) {
      animations.updateListItem(cartItemImage.current).play();
    }
    setIsFirstRender(false);
  }, [amount]);
  React.useEffect(() => {
    if (amount === 1 && lastUpdatedFromType === APPEND && isAnimatingOnRender) {
      const a = animations.addListItem(cartItem.current);
      a.eventCallback('onComplete', () => {
        onRenderAnimationComplete && onRenderAnimationComplete(productId, productVariation, type, skinId);
      });
      a.play();
    }
  }, []);
  const handleProductAmountChange = value => {
    if (value < 1) {
      handleProductRemoveClick();
    } else {
      onProductAmountChange && onProductAmountChange(productId, productVariation, type, value, skinId);
    }
  };
  if (!product) {
    return null;
  }

  const productNameAndPrice = RegExp(/[0-9]{2,3}\b\skr\b/g).test(productName.toLowerCase()) ? productName : "".concat(productName, " ").concat(productPrice, " kr");
  return React.createElement("div", {
    className: "tg-cart-item",
    "data-testid": "tg-cart-item-test-id",
    ref: cartItem
  }, React.createElement("figure", {
    className: "tg-cart-item-image",
    ref: cartItemImage
  }, React.createElement(Image, {
    cssSelectors: "tg-cart-item-image-img",
    image: _objectSpread(_objectSpread({}, productImage), {}, {
      altText: "".concat(productName, " bild"),
      sizes: '(min-width: 320px) 320px, 100vw'
    })
  })), React.createElement("div", {
    className: "tg-cart-item-product-name"
  }, productNameAndPrice), React.createElement(InputNumber, {
    className: "tg-input-number",
    focus: false,
    onValueChange: handleProductAmountChange,
    size: 100,
    step: 1,
    value: amount
  }), React.createElement(IconButton, {
    className: "tg-cart-item-icon-button",
    onClick: handleProductRemoveClick
  }, React.createElement(Icon, {
    color: "fc-black",
    icon: "remove-sign",
    size: "400"
  })));
};
const mapDispatchToProps = dispatch => ({
  onRenderAnimationComplete: (productId, productVariation, type, skinId) => dispatch(setRenderAnimationCompleteAction(productId, productVariation, type, skinId)),
  onProductGroupRemove: (productId, productVariation, type, skinId) => dispatch(removeProductGroupAction(productId, productVariation, type, skinId)),
  onProductAmountChange: (productId, productVariation, type, amount, skinId) => dispatch(setProductAction(productId, productVariation, type, amount, skinId))
});
svs.tickets_giftshop.gift.giftform.cart.components.Item = ReactRedux.connect(null, mapDispatchToProps)(Item);

 })(window);